export const siteInfo = {
  brand: "出轨同学会",
  brandEn: "Reunion Affair",
  tagline: "一场同学会，翻开了所有人的旧账",
  titleEn: "Reunion Affair",
  year: "2025",
  region: "中国大陆",
  genre: "都市 · 情感 · 悬疑",
  episodeCount: 24,
  updatedTo: 16,
  director: "顾承安",
  screenwriter: "苏晚宁 · 裴之远",
  rating: "8.7",
  status: "全网热播中",
  intro:
    "《出轨同学会》以一场十年后的高中同学会为起点，将一群曾经亲密无间、如今各怀心事的成年人重新聚拢在一张餐桌前。随着旧照片、旧语音与一封迟来的信件被逐一揭开，每个人看似体面的生活都开始出现裂缝。",
  intro2:
    "本站专注于整理该剧的全集剧情脉络、主演阵容与更新动态，帮助影迷在追剧之余快速查阅每一集的关键情节与人物关系，也为尚未入坑的观众提供完整的入坑指南。",
  email: "hi@chuguistudentmeeting.example.com",
  feedbackNote: "如对剧集资料、页面内容有补充或纠错建议，欢迎通过下方反馈表单联系我们。",
  icp: "本站为影视资料演示站点，所有剧照、剧情与人物均为示例内容，不提供任何真实播放或下载服务。",
};

export const categoryMeta = {
  synopsis: {
    key: "synopsis",
    title: "剧情介绍",
    subtitle: "逐集梳理关键情节与人物关系走向",
    description:
      "出轨同学会剧情介绍专区，按集整理该剧的完整剧情脉络，涵盖同学会初见、旧账翻涌、真相揭晓等关键节点，帮助你快速掌握每一集的核心冲突与人物变化。",
    keywords: "出轨同学会剧情,同学会剧情介绍,出轨同学会分集剧情,剧情梳理",
  },
  cast: {
    key: "cast",
    title: "主演信息",
    subtitle: "完整演员阵容与角色设定档案",
    description:
      "出轨同学会主演信息专区，收录该剧主要演员与所饰演角色，包含角色身份、性格设定与人物关系，方便影迷了解演员阵容与角色背景。",
    keywords: "出轨同学会主演,出轨同学会演员表,同学会角色介绍,主演阵容",
  },
  updates: {
    key: "updates",
    title: "剧集更新",
    subtitle: "最新更新时间与追剧进度速览",
    description:
      "出轨同学会剧集更新专区，汇总该剧全部剧集的更新时间、集数进度与剧情摘要，方便追剧观众掌握最新更新节奏。",
    keywords: "出轨同学会更新,出轨同学会更新时间,剧集更新,追剧进度",
  },
};

export const aboutInfo = {
  sections: [
    {
      title: "站点目标",
      body: "出轨同学会影视内容站是一个非商业性质的剧集资料整理站点，聚焦电视剧《出轨同学会》的剧情介绍、主演信息与剧集更新，力求以整洁、结构化的方式呈现完整剧集资料。",
    },
    {
      title: "内容范围",
      body: "本站内容涵盖逐集剧情梳理、人物关系解读、演员与角色档案以及更新动态。所有剧照、简介与人物设定均为演示用示例内容，仅供资料查阅与页面展示。",
    },
    {
      title: "使用说明",
      body: "你可以通过顶部导航进入剧情介绍、主演信息与剧集更新分类，也可以使用搜索功能按关键词查找相关剧情或演员；在剧集详情页点击收藏按钮，可将喜欢的剧集保存在本机浏览器中，方便下次快速回访。",
    },
    {
      title: "内容声明",
      body: "本站不提供也不涉及任何真实视频播放、下载或第三方接口，页面中的播放、收藏等交互均为前端演示。若你对内容有任何补充或纠错，欢迎通过反馈表单与我们联系。",
    },
  ],
};